import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,
          LoadingController, Loading, AlertController } from 'ionic-angular';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ContactItem } from '../contacts/contactitem';
import { DatabaseProvider } from '../../providers/database/database';
import { UIProvider } from '../../providers/ui/ui';

import { Camera, CameraOptions } from '@ionic-native/camera';

/**
 * Generated class for the ContactsAddPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-contacts-add',
  templateUrl: 'contacts-add.html',
})
export class ContactsAddPage {

  captureDataUrls: any = [];
  contactForm: FormGroup;
  loading: Loading;

  constructor(public navCtrl: NavController, public navParams: NavParams,  
  public formBuilder: FormBuilder, public alertCtrl: AlertController,
  public loadingCtrl: LoadingController, public dbProvider: DatabaseProvider,
  public uiProvider: UIProvider, public camera: Camera) {

   this.contactForm = formBuilder.group({
      lastname: ['', Validators.compose([Validators.minLength(2), 
      Validators.required])],
      firstname: ['', Validators.compose([Validators.minLength(2), 
      Validators.required])],
      address: ['', Validators.compose([Validators.minLength(6), 
      Validators.required])],
      tel1: ['', Validators.compose([Validators.minLength(6), 
      Validators.required])],
      tel2: ['', Validators.compose([Validators.minLength(6)])],
      email: ['', Validators.compose([Validators.minLength(3)])],
      farms: ['', Validators.compose([Validators.minLength(3)])],
      notes: ['', Validators.compose([Validators.minLength(2)])],
      pic1: ['', Validators.compose([Validators.minLength(2)])],
      pic2: ['', Validators.compose([Validators.minLength(2)])],
      pic3: ['', Validators.compose([Validators.minLength(2)])]
    });
  
    //this.captureDataUrls = new Array<string>();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ContactsAddPage');
  }
  
  saveContact() {
    console.log('ionViewDidLoad ContactsAddPage saveContact(...)');
    if (!this.contactForm.valid){
      console.log(this.contactForm.value);
      console.log('ContactsAddPage user entry invalid(...)');
    } else {
      console.log('lastname: ' + this.contactForm.value.lastname);
      const aContactItem : ContactItem = {
        lastname : this.contactForm.value.lastname,
        firstname : this.contactForm.value.firstname,
        address : this.contactForm.value.address,
        tel1 : this.contactForm.value.tel1,
        tel2 : this.contactForm.value.tel2,
        email : this.contactForm.value.email,
        farms : this.contactForm.value.farms,
        notes : this.contactForm.value.notes,
        /*,
        pic1 : this.contactForm.value.pic1,
        pic2 : this.contactForm.value.pic2,
        pic3 : this.contactForm.value.pic3
        */
        id : this.dbProvider.getDBId()
      }


      console.log('saving... ' + aContactItem.lastname + ', ' + aContactItem.firstname);
      this.dbProvider.saveContact(aContactItem);
      this.uiProvider.presentToast( "Successfully saved " + aContactItem.lastname 
                                                  + ', ' + aContactItem.firstname, 3000);
      this.navCtrl.pop();
    }
  }

  cameraCapture(index: Number){
    const options: CameraOptions = {
      quality: 50,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      cameraDirection: this.camera.Direction.BACK,
      mediaType: this.camera.MediaType.PICTURE
    }

    this.camera.getPicture(options).then((imageData) => {
    // imageData is either a base64 encoded string or a file URI
    // If it's base64:
          if(index == 1)
          {
            this.contactForm.value.pic1 = 'data:image/jpeg;base64,' + imageData;
          }
          else if(index == 2)
          {
            this.contactForm.value.pic2 = 'data:image/jpeg;base64,' + imageData;
          }
          else if(index == 3)
          {
            this.contactForm.value.pic3 = 'data:image/jpeg;base64,' + imageData;
          }
          else
          {
            console.log('CameraCapture index unexpected: ' + index);
          }
    }, (err) => {
    // Handle error
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/contacts-add/contacts-add.ts